import { Container, SectionWrapper } from '@/components';
import styled from 'styled-components';

export const AppBadgeSectionContainer = styled(SectionWrapper)`
  ${({ theme }) => theme.mediaBreakpointUp.md} {
    :not(:last-child) {
      margin-bottom: ${({ theme }) => theme.spacing[24]};
    }
  }

  ${({ theme }) => theme.mediaBreakpointDown.md} {
    border: solid ${({ theme }) => theme.colors.surface05};
    border-width: 2px 0px 2px 0px;
  }
`;

export const SectionContainer = styled(Container)`
  padding: ${({ theme }) => theme.spacing[20]};
`;

export const AppShowcase = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing[20]};
  
  ${({ theme }) => theme.mediaBreakpointUp.md} {
    flex-direction: row;
    align-items: center;
  }
`;

export const AppInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[16]};
`;

export const AppTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[8]};
`;

export const MainTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.highEmphasisBlack};
  margin: 0;
`;

export const SubText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.mediumEmphasisBlack};
  margin: 0;
`;

export const DownloadButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const AppImageContainer = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  
  ${({ theme }) => theme.mediaBreakpointUp.md} {
    margin-top: 0;
    justify-content: flex-end;
  }

  > img {
    position: relative !important;
  }
`;
